import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  px: 2,
  py: 1.5,
  background: (p) => p.palette.common.white,
};
